export default __webpack_public_path__ + "static/media/sprite.68ef48a4.svg";